export default __webpack_public_path__ + "static/media/techblog3-fig5.832ea610.png";